__turbopack_context__.v({
  "cardsGrid": "ContactView-module__PELuIq__cardsGrid",
  "container": "ContactView-module__PELuIq__container",
  "heroContent": "ContactView-module__PELuIq__heroContent",
  "heroDescription": "ContactView-module__PELuIq__heroDescription",
  "heroSection": "ContactView-module__PELuIq__heroSection",
  "heroTitle": "ContactView-module__PELuIq__heroTitle",
  "page": "ContactView-module__PELuIq__page",
});
